var map = {
	"./Saudi_League.jpg": 31059,
	"./achievements/25golesChampions.jpg": 15033,
	"./achievements/60transferValue.jpg": 56772,
	"./achievements/7golesMundo.jpg": 25468,
	"./achievements/african_player.jpg": 46733,
	"./achievements/asian_player.jpg": 88622,
	"./achievements/balon_oro.jpg": 26240,
	"./achievements/bota_oro.jpg": 75071,
	"./achievements/campeon_mundo.jpg": 82461,
	"./achievements/champions.jpg": 76652,
	"./achievements/concacaf_player.jpg": 71505,
	"./achievements/conference_league.jpg": 29596,
	"./achievements/copa_america.jpg": 93302,
	"./achievements/copa_argentina.jpg": 36260,
	"./achievements/eurocopa.jpg": 9042,
	"./achievements/europa_league.jpg": 38146,
	"./achievements/goldenboy.jpg": 67479,
	"./achievements/jjoo.jpg": 81671,
	"./achievements/nations_league.jpg": 39099,
	"./achievements/premier_league.jpg": 10905,
	"./achievements/puskas.jpg": 8750,
	"./achievements/triplete.jpg": 52525,
	"./country/Afganistan.jpg": 78630,
	"./country/Aland Islas.jpg": 80778,
	"./country/Albania.jpg": 75065,
	"./country/Alemania.jpg": 65400,
	"./country/Andorra.jpg": 75241,
	"./country/Angola.jpg": 70445,
	"./country/Anguila.jpg": 84732,
	"./country/Antartida.jpg": 86506,
	"./country/Antigua y Barbuda.jpg": 21883,
	"./country/Arabia Saudita.jpg": 6970,
	"./country/Argelia.jpg": 28714,
	"./country/Argentina.jpg": 20567,
	"./country/Armenia.jpg": 84330,
	"./country/Aruba.jpg": 50840,
	"./country/Australia.jpg": 8744,
	"./country/Austria.jpg": 97356,
	"./country/Azerbaiyan.jpg": 48673,
	"./country/Bahamas.jpg": 24070,
	"./country/Banglades.jpg": 72733,
	"./country/Barbados.jpg": 57972,
	"./country/Barein.jpg": 40950,
	"./country/Belgica.jpg": 60106,
	"./country/Belice.jpg": 52377,
	"./country/Benin.jpg": 75019,
	"./country/Bermudas.jpg": 67763,
	"./country/Bhutan.jpg": 35715,
	"./country/Bielorrusia.jpg": 16808,
	"./country/Bolivia.jpg": 9712,
	"./country/Bonaire, San Eustaquio y Saba.jpg": 24984,
	"./country/Bosnia y Herzegovina.jpg": 14009,
	"./country/Botsuana.jpg": 49660,
	"./country/Bouvet, Isla.jpg": 92819,
	"./country/Brasil.jpg": 78711,
	"./country/Brunei Darussalam.jpg": 55016,
	"./country/Burkina Faso.jpg": 52142,
	"./country/Burundi.jpg": 62067,
	"./country/Cabo Verde.jpg": 50168,
	"./country/Caiman, (las) Islas.jpg": 65778,
	"./country/Camboya.jpg": 56296,
	"./country/Camerun.jpg": 34676,
	"./country/Canada.jpg": 34331,
	"./country/Chad.jpg": 30973,
	"./country/Chile.jpg": 55881,
	"./country/China.jpg": 94507,
	"./country/Chipre.jpg": 31016,
	"./country/Christmas, Isla.jpg": 27863,
	"./country/Colombia.jpg": 43893,
	"./country/Comoras.jpg": 47845,
	"./country/Congo.jpg": 2257,
	"./country/Cook, Islas.jpg": 79173,
	"./country/Corea del Norte.jpg": 33825,
	"./country/Corea del Sur.jpg": 51299,
	"./country/Costa Rica.jpg": 55149,
	"./country/Costa de Marfil.jpg": 98057,
	"./country/Croacia.jpg": 41983,
	"./country/Cuba.jpg": 50278,
	"./country/Curazao.jpg": 93143,
	"./country/Dinamarca.jpg": 33371,
	"./country/Dominica.jpg": 414,
	"./country/Ecuador.jpg": 98552,
	"./country/Egipto.jpg": 16467,
	"./country/El Salvador.jpg": 63322,
	"./country/Emiratos Arabes Unidos.jpg": 67075,
	"./country/Eritrea.jpg": 76446,
	"./country/Escocia.jpg": 36974,
	"./country/Eslovaquia.jpg": 9889,
	"./country/Eslovenia.jpg": 65337,
	"./country/España.jpg": 50866,
	"./country/Estados Unidos.jpg": 95481,
	"./country/Estonia.jpg": 15452,
	"./country/Eswatini.jpg": 65195,
	"./country/Etiopia.jpg": 35542,
	"./country/Filipinas.jpg": 3953,
	"./country/Finlandia.jpg": 11906,
	"./country/Fiyi.jpg": 9787,
	"./country/Francia.jpg": 48395,
	"./country/Gabon.jpg": 44401,
	"./country/Gales.jpg": 2512,
	"./country/Gambia.jpg": 69028,
	"./country/Georgia del Sur (la) y las Islas Sandwich del Sur.jpg": 45396,
	"./country/Georgia.jpg": 81970,
	"./country/Ghana.jpg": 1475,
	"./country/Gibraltar.jpg": 8813,
	"./country/Granada.jpg": 55735,
	"./country/Grecia.jpg": 1237,
	"./country/Groenlandia.jpg": 94504,
	"./country/Guadalupe.jpg": 24028,
	"./country/Guam.jpg": 38629,
	"./country/Guatemala.jpg": 67274,
	"./country/Guayana Francesa.jpg": 23374,
	"./country/Guernsey.jpg": 67230,
	"./country/Guinea Ecuatorial.jpg": 35092,
	"./country/Guinea-Bissau.jpg": 2947,
	"./country/Guinea.jpg": 1769,
	"./country/Guyana.jpg": 340,
	"./country/Haiti.jpg": 67989,
	"./country/Heard (Isla) e Islas McDonald.jpg": 83811,
	"./country/Honduras.jpg": 3668,
	"./country/Hong Kong.jpg": 60753,
	"./country/Hungria.jpg": 72063,
	"./country/India.jpg": 45470,
	"./country/Indonesia.jpg": 69962,
	"./country/Inglaterra.jpg": 94306,
	"./country/Iran.jpg": 17609,
	"./country/Iraq.jpg": 29354,
	"./country/Irlanda del Norte.jpg": 58201,
	"./country/Irlanda.jpg": 48583,
	"./country/Isla de Man.jpg": 84183,
	"./country/Isla de San Martin.jpg": 22234,
	"./country/Islandia.jpg": 47589,
	"./country/Islas Feroe.jpg": 82366,
	"./country/Islas menores alejadas de Estados Unidos.jpg": 79649,
	"./country/Israel.jpg": 62695,
	"./country/Italia.jpg": 60871,
	"./country/Jamaica.jpg": 78557,
	"./country/Japon.jpg": 18249,
	"./country/Jersey.jpg": 55240,
	"./country/Jordania.jpg": 37445,
	"./country/Kazajistan.jpg": 48631,
	"./country/Kenia.jpg": 69935,
	"./country/Kirguistan.jpg": 87732,
	"./country/Kiribati.jpg": 72173,
	"./country/Kosovo.jpg": 53353,
	"./country/Kuwait.jpg": 810,
	"./country/Lao, (la) Republica Democratica Popular.jpg": 82382,
	"./country/Lesoto.jpg": 85205,
	"./country/Letonia.jpg": 47136,
	"./country/Libano.jpg": 6368,
	"./country/Liberia.jpg": 46541,
	"./country/Libia.jpg": 42723,
	"./country/Liechtenstein.jpg": 65575,
	"./country/Lituania.jpg": 76482,
	"./country/Luxemburgo.jpg": 30041,
	"./country/Macao.jpg": 19750,
	"./country/Macedonia del Norte.jpg": 88527,
	"./country/Madagascar.jpg": 87623,
	"./country/Malasia.jpg": 9821,
	"./country/Malawi.jpg": 86005,
	"./country/Maldivas.jpg": 4443,
	"./country/Mali.jpg": 52942,
	"./country/Malta.jpg": 75584,
	"./country/Malvinas [Falkland], (las) Islas.jpg": 94312,
	"./country/Marianas Septentrionales, (las) Islas.jpg": 54903,
	"./country/Marruecos.jpg": 50003,
	"./country/Marshall, (las) Islas.jpg": 74007,
	"./country/Martinica.jpg": 55528,
	"./country/Mauricio.jpg": 89388,
	"./country/Mauritania.jpg": 24794,
	"./country/Mayotte.jpg": 49343,
	"./country/Mexico.jpg": 99364,
	"./country/Micronesia (Estados Federados de).jpg": 7691,
	"./country/Moldova (la Republica de).jpg": 15059,
	"./country/Mongolia.jpg": 12293,
	"./country/Montenegro.jpg": 70395,
	"./country/Montserrat.jpg": 45802,
	"./country/Mozambique.jpg": 58134,
	"./country/Myanmar.jpg": 12516,
	"./country/Namibia.jpg": 21001,
	"./country/Nauru.jpg": 95099,
	"./country/Nepal.jpg": 6622,
	"./country/Nicaragua.jpg": 41311,
	"./country/Niger.jpg": 60128,
	"./country/Nigeria.jpg": 14317,
	"./country/Niue.jpg": 63215,
	"./country/Norfolk, Isla.jpg": 31607,
	"./country/Noruega.jpg": 62601,
	"./country/Nueva Caledonia.jpg": 5464,
	"./country/Nueva Zelanda.jpg": 42125,
	"./country/Oman.jpg": 28420,
	"./country/Paises Bajos.jpg": 7090,
	"./country/Pakistan.jpg": 77758,
	"./country/Palau.jpg": 74089,
	"./country/Palestina.jpg": 94751,
	"./country/Panama.jpg": 34305,
	"./country/Papua Nueva Guinea.jpg": 20408,
	"./country/Paraguay.jpg": 4918,
	"./country/Peru.jpg": 38004,
	"./country/Pitcairn.jpg": 58767,
	"./country/Polonia.jpg": 29093,
	"./country/Portugal.jpg": 80401,
	"./country/Puerto Rico.jpg": 59554,
	"./country/Qatar.jpg": 85404,
	"./country/R.D. Congo.jpg": 84038,
	"./country/Reino Unido.jpg": 66438,
	"./country/Rep. Dominicana.jpg": 7790,
	"./country/Republica Arabe Siria.jpg": 64394,
	"./country/Republica Centroafricana.jpg": 53073,
	"./country/Republica Checa.jpg": 28475,
	"./country/Reunion.jpg": 2234,
	"./country/Ruanda.jpg": 63272,
	"./country/Rumania.jpg": 7481,
	"./country/Rusia.jpg": 93541,
	"./country/Sahara Occidental.jpg": 51651,
	"./country/Salomon, Islas.jpg": 96995,
	"./country/Samoa Americana.jpg": 44833,
	"./country/Samoa.jpg": 56380,
	"./country/San Barthelemy.jpg": 96836,
	"./country/San Cristobal y Nieves.jpg": 96384,
	"./country/San Marino.jpg": 91049,
	"./country/San Martin (parte francesa).jpg": 94098,
	"./country/San Pedro y Miquelon.jpg": 69902,
	"./country/San Vicente y las Granadinas.jpg": 30751,
	"./country/Santa Elena, Ascension y Tristan de Acuña.jpg": 37470,
	"./country/Santa Lucia.jpg": 88398,
	"./country/Santa Sede.jpg": 24261,
	"./country/Santo Tome y Principe.jpg": 9833,
	"./country/Senegal.jpg": 41597,
	"./country/Serbia.jpg": 90304,
	"./country/Seychelles.jpg": 28778,
	"./country/Sierra Leona.jpg": 59761,
	"./country/Singapur.jpg": 85951,
	"./country/Somalia.jpg": 32139,
	"./country/Sri Lanka.jpg": 38123,
	"./country/Sudafrica.jpg": 54466,
	"./country/Sudan del Sur.jpg": 39759,
	"./country/Sudan.jpg": 36562,
	"./country/Suecia.jpg": 46187,
	"./country/Suiza.jpg": 39885,
	"./country/Surinam.jpg": 35658,
	"./country/Svalbard y Jan Mayen.jpg": 71314,
	"./country/Tahiti.jpg": 72164,
	"./country/Tailandia.jpg": 80439,
	"./country/Taiwan.jpg": 22975,
	"./country/Tanzania.jpg": 99467,
	"./country/Tayikistan.jpg": 77362,
	"./country/Territorio Britanico del Oceano Indico (el).jpg": 81931,
	"./country/Tierras Australes Francesas.jpg": 40055,
	"./country/Timor-Leste.jpg": 23529,
	"./country/Togo.jpg": 34383,
	"./country/Tokelau.jpg": 93398,
	"./country/Tonga.jpg": 21459,
	"./country/Trinidad y Tobago.jpg": 59943,
	"./country/Tunez.jpg": 90183,
	"./country/Turcas y Caicos, Islas.jpg": 27534,
	"./country/Turkmenistan.jpg": 60186,
	"./country/Turquia.jpg": 17649,
	"./country/Tuvalu.jpg": 133,
	"./country/Ucrania.jpg": 59538,
	"./country/Uganda.jpg": 86141,
	"./country/Uruguay.jpg": 53325,
	"./country/Uzbekistan.jpg": 9332,
	"./country/Vanuatu.jpg": 67481,
	"./country/Venezuela.jpg": 86102,
	"./country/Vietnam.jpg": 58719,
	"./country/Virgenes Britanicas, Islas.jpg": 82730,
	"./country/Virgenes de los Estados Unidos, Islas.jpg": 59163,
	"./country/Wallis y Futuna.jpg": 92321,
	"./country/Yemen.jpg": 99829,
	"./country/Yibuti.jpg": 37552,
	"./country/Zambia.jpg": 93612,
	"./country/Zimbabwe.jpg": 60799,
	"./defaultPlayer.jpg": 48798,
	"./dt/Ancelotti.jpg": 97983,
	"./dt/Guardiola.jpg": 29274,
	"./dt/Mourinho.jpg": 75221,
	"./dt/messi.jpg": 6825,
	"./goback.jpg": 46957,
	"./home/build11.jpg": 25928,
	"./home/roster.jpg": 80509,
	"./home/tictactoe-bot.jpg": 42342,
	"./home/tictactoe-bot12.jpg": 35296,
	"./home/tictactoe-bot2.jpg": 86805,
	"./home/tictactoe-bot3.jpg": 74655,
	"./home/tictactoe-local.jpg": 66236,
	"./home/tictactoe-online.jpg": 1547,
	"./home/tictactoe.jpg": 34633,
	"./positions/Defender.jpg": 75895,
	"./positions/Forward.jpg": 15368,
	"./positions/Goalkeeper.jpg": 57921,
	"./positions/Midfielder.jpg": 95702,
	"./teams/Saudi_League.jpg": 19986,
	"./teams/ajax.jpg": 16509,
	"./teams/aldosivi.jpg": 2525,
	"./teams/all-boys.jpg": 50533,
	"./teams/allLPF.jpg": 42842,
	"./teams/argentinos-juniors.jpg": 56423,
	"./teams/arsenal-de-sarandi.jpg": 69486,
	"./teams/arsenal.jpg": 42666,
	"./teams/aston_villa.jpg": 99729,
	"./teams/atalanta.jpg": 13108,
	"./teams/atenas.jpg": 72563,
	"./teams/atlante.jpg": 84958,
	"./teams/atlas_guadalajara.jpg": 68199,
	"./teams/atletico-rafaela.jpg": 40482,
	"./teams/atletico-tucuman.jpg": 39154,
	"./teams/atletico_madrid.jpg": 53668,
	"./teams/atletico_morelia.jpg": 91226,
	"./teams/atletico_san_luis.jpg": 79656,
	"./teams/banfield.jpg": 14818,
	"./teams/barcelona.jpg": 18866,
	"./teams/barracas-central.jpg": 29029,
	"./teams/bayern_munich.jpg": 49223,
	"./teams/belgrano-de-cordoba.jpg": 90894,
	"./teams/benfica.jpg": 62612,
	"./teams/boca-juniors.jpg": 9661,
	"./teams/bologna.jpg": 52740,
	"./teams/borussia_dortmund.jpg": 60319,
	"./teams/boston_river.jpg": 65751,
	"./teams/bournemouth.jpg": 20352,
	"./teams/brentford-fc.jpg": 27229,
	"./teams/brighton_and_hove_albion.jpg": 66173,
	"./teams/burnley-fc.jpg": 45477,
	"./teams/ca_cerro.jpg": 81224,
	"./teams/cardiff-city.jpg": 28412,
	"./teams/celtic.jpg": 40162,
	"./teams/central-cordoba-sde.jpg": 39603,
	"./teams/cerrito.jpg": 10057,
	"./teams/cerro_largo.jpg": 7052,
	"./teams/cf_america.jpg": 27921,
	"./teams/cf_monterrey.jpg": 86772,
	"./teams/cf_pachuca.jpg": 39174,
	"./teams/chacarita-juniors_2.jpg": 8000,
	"./teams/chelsea.jpg": 34182,
	"./teams/club_leon.jpg": 38984,
	"./teams/club_necaxa.jpg": 76393,
	"./teams/club_tijuana.jpg": 57444,
	"./teams/colon-de-santa-fe.jpg": 99403,
	"./teams/como.jpg": 1230,
	"./teams/cruz_azul.jpg": 97508,
	"./teams/crystal-palace.jpg": 23503,
	"./teams/crystal_palace.jpg": 5179,
	"./teams/danubio.jpg": 76117,
	"./teams/defensa-y-justicia.jpg": 3515,
	"./teams/defensor_sporting.jpg": 43565,
	"./teams/deportivo_guadalajara.jpg": 65949,
	"./teams/deportivo_maldonado.jpg": 61584,
	"./teams/deportivo_toluca.jpg": 43682,
	"./teams/dorados_de_sinaloa.jpg": 16311,
	"./teams/estudiantes.jpg": 70584,
	"./teams/everton.jpg": 27935,
	"./teams/fc_juarez.jpg": 37561,
	"./teams/fenix_uru.jpg": 59267,
	"./teams/ferro-carril-oeste.jpg": 50305,
	"./teams/feyenoord.jpg": 29886,
	"./teams/fiorentina.jpg": 60849,
	"./teams/fulham-fc.jpg": 1329,
	"./teams/galatasaray.jpg": 50220,
	"./teams/gimnasia-de-la-plata.jpg": 5013,
	"./teams/godoy-cruz.jpg": 85157,
	"./teams/hull-city.jpg": 43536,
	"./teams/huracan.jpg": 3976,
	"./teams/independiente-rivadavia.jpg": 78398,
	"./teams/independiente.jpg": 32722,
	"./teams/instituto-de-cordoba.jpg": 54026,
	"./teams/inter.jpg": 16507,
	"./teams/juventus.jpg": 70402,
	"./teams/la_luz.jpg": 45096,
	"./teams/lanus.jpg": 86263,
	"./teams/lazio.jpg": 50701,
	"./teams/leeds_united.jpg": 24360,
	"./teams/leicester.jpg": 92710,
	"./teams/leipzig.jpg": 73611,
	"./teams/liverpool.jpg": 7974,
	"./teams/liverpool_uru.jpg": 73728,
	"./teams/luton-town.jpg": 68154,
	"./teams/manchester_city.jpg": 80593,
	"./teams/manchester_united.jpg": 48275,
	"./teams/mazatlan_fc.jpg": 34531,
	"./teams/milan.jpg": 54368,
	"./teams/monaco.jpg": 23215,
	"./teams/montevideo_city_torque.jpg": 80765,
	"./teams/montevideo_wanderers.jpg": 45122,
	"./teams/nacional.jpg": 63726,
	"./teams/napoli.jpg": 6876,
	"./teams/newcastle.jpg": 13098,
	"./teams/newells-old-boys.jpg": 62850,
	"./teams/norwich-city.jpg": 98044,
	"./teams/nottingham_forest.jpg": 57655,
	"./teams/nueva-chicago.jpg": 87313,
	"./teams/olympique_lyon.jpg": 37644,
	"./teams/olympique_marseille.jpg": 10427,
	"./teams/patronato-de-parana.jpg": 52135,
	"./teams/penarol.jpg": 25387,
	"./teams/platense.jpg": 68773,
	"./teams/plaza_colonia.jpg": 92821,
	"./teams/porto.jpg": 232,
	"./teams/progreso.jpg": 26123,
	"./teams/psg.jpg": 79172,
	"./teams/psv.jpg": 42576,
	"./teams/puebla_fc.jpg": 67651,
	"./teams/pumas_unam.jpg": 78450,
	"./teams/queens-park-rangers.jpg": 95421,
	"./teams/queretaro.jpg": 98705,
	"./teams/quilmes.jpg": 10053,
	"./teams/racing-club.jpg": 79352,
	"./teams/racing_uru.jpg": 61863,
	"./teams/rampla_juniors.jpg": 41130,
	"./teams/real_betis.jpg": 56162,
	"./teams/real_madrid.jpg": 74308,
	"./teams/rentistas.jpg": 60608,
	"./teams/river-plate.jpg": 75471,
	"./teams/river_plate_uru.jpg": 29670,
	"./teams/roma.jpg": 17873,
	"./teams/rosario-central.jpg": 57311,
	"./teams/san-lorenzo.jpg": 85022,
	"./teams/san-martin-de-san-juan.jpg": 10829,
	"./teams/santos_laguna.jpg": 85477,
	"./teams/sarmiento-de-junin.jpg": 80210,
	"./teams/sevilla.jpg": 19606,
	"./teams/sheffield-united.jpg": 12278,
	"./teams/sheffield-wednesday.jpg": 91947,
	"./teams/southampton.jpg": 52131,
	"./teams/sporting_cp.jpg": 28371,
	"./teams/stoke-city.jpg": 95565,
	"./teams/sunderland.jpg": 73537,
	"./teams/swansea-city.jpg": 74515,
	"./teams/talleres-de-cordoba.jpg": 52016,
	"./teams/temperley.jpg": 1217,
	"./teams/tigre.jpg": 25149,
	"./teams/tottenham_hotspur.jpg": 16527,
	"./teams/uanl_tigres.jpg": 88751,
	"./teams/udinese.jpg": 67087,
	"./teams/union_santa_fe.jpg": 28444,
	"./teams/uruguay_montevideo.jpg": 2373,
	"./teams/valencia.jpg": 26484,
	"./teams/velez-sarsfield.jpg": 31141,
	"./teams/villarreal.jpg": 33387,
	"./teams/watford-fc.jpg": 65025,
	"./teams/west-bromwich-albion.jpg": 31137,
	"./teams/west_ham_united.jpg": 14289,
	"./teams/wolverhampton-wanderers.jpg": 53294,
	"./years/25.jpg": 23819,
	"./years/35.jpg": 66181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49931;